<template>
  <div class="sketch" ref="sketch__container"></div>
</template>

<script>
import p5 from "p5";
export default {
  name: "Sketch",
  props: ["data", "username", "displayName"],
  mounted() {
    new p5(this.sketch, this.$refs.sketch__container);
  },
  methods: {
    stringToSeed(string) {
      // eslint-disable-next-line
      let slug = string.replace(
        // eslint-disable-next-line
        /[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi,
        ""
      );
      let seed = "";
      for (const letter of slug) {
        seed += letter.toLowerCase().charCodeAt(0) - 97 + 1;
      }
      return seed;
    },
    sketch(sketch) {
      const seedRandom = this.stringToSeed(this.username);
      let initials = [];
      const tiles = 6;
      const padding = 1;
      const center = tiles / 2;
      let unit;
      let shapeColor;
      let font = require("../assets/fonts/SwatchCTWeb-Bold.ttf");
      let sketchFont;

      sketch.preload = () => {
        sketchFont = sketch.loadFont(font);
      }

      sketch.setup = () => {
        sketch.createCanvas(300, 300);
        unit = sketch.width / tiles;
        sketch.rectMode(sketch.CENTER);
        sketch.ellipseMode(sketch.CENTER);
        sketch.noStroke();
      };

      sketch.draw = () => {
        sketch.randomSeed(seedRandom);
        sketch.fill(this.data.LightVibrant);
        sketch.background(255);
        sketch.noStroke();
        sketch.ellipse(
          sketch.width / 2,
          sketch.height / 2,
          sketch.width,
          sketch.height
        );
        sketch.addBackground();
        sketch.addInitials();
        sketch.gridShapes();
        // sketch.addGrid();
        // sketch.noLoop();
      };

      /**
       *
       * UTILITIES FUNCTIONS
       */

      // ADD GRID
      sketch.addGrid = () => {
        sketch.stroke(0);
        sketch.strokeWeight(1);
        for (let indexX = 0; indexX < tiles; indexX++) {
          for (let indexY = 0; indexY < tiles; indexY++) {
            const posX = (sketch.width / tiles) * indexX;
            const posY = (sketch.height / tiles) * indexY;
            sketch.line(posX, posY, posX + 1 * (sketch.width / tiles), posY);
            sketch.line(posX, posY, posX, posY + 1 * (sketch.height / tiles));
          }
        }
        sketch.noStroke();
      };

      // BACKGROUND SHAPE
      sketch.addBackground = () => {
        sketch.fill(this.data.Vibrant);
        sketch.noStroke();

        const bgRandom = Math.floor(sketch.random(12));
        switch (bgRandom) {
          case 0:
            sketch.bgCircle();
            break;
          case 1:
            sketch.bgSquare();
            break;
          case 2:
            sketch.bgDiamond();
            break;
          case 3:
            sketch.bgTriangle();
            break;
          case 4:
            sketch.bgArc();
            break;
          case 5:
            sketch.bgRect();
            break;
          case 6:
            sketch.bgEye();
            break;
          case 7:
            sketch.bgCross();
            break;
          case 8:
            sketch.bgPolygon();
            break;
          case 9:
            sketch.bgStar();
            break;
          case 10:
            sketch.bgTear();
            break;
          case 11:
            sketch.bgMoon();
            break;

          default:
            break;
        }
      };

      sketch.addInitials = () => {
        initials = [];
        let firstLetter, secondLetter;
        if (this.displayName.split(" ").length >= 2) {
          firstLetter = this.displayName.split(" ")[0][0];
          secondLetter = this.displayName.split(" ")[1][0];
        } else {
          firstLetter = this.displayName[0];
          secondLetter = this.displayName[this.displayName.length - 1];
        }
        initials.push({
          x: Math.floor(sketch.random(4, tiles - 1) / 2),
          y: Math.floor(sketch.random(4, tiles - 1) / 2)
        });

        initials.push({
          x: Math.floor(sketch.random(initials[0].x + 1, tiles - 1)),
          y: Math.floor(sketch.random(initials[0].y + 1, tiles - 1))
        });
        sketch.textFont(sketchFont);
        sketch.textSize(unit * 0.8);
        sketch.fill(255);
        sketch.textAlign(sketch.CENTER, sketch.CENTER);

        const flPosX = (sketch.width / tiles) * initials[0].x;
        const flPosY = (sketch.width / tiles) * initials[0].y;
        sketch.translate(flPosX, flPosY);
        sketch.text(firstLetter.toUpperCase(), unit / 2, unit / 2);
        sketch.translate(flPosX * -1, flPosY * -1);

        const slPosX = (sketch.width / tiles) * initials[1].x;
        const slPosY = (sketch.width / tiles) * initials[1].y;
        sketch.translate(slPosX, slPosY);
        sketch.text(secondLetter.toUpperCase(), unit / 2, unit / 2);
        sketch.translate(slPosX * -1, slPosY * -1);
      };

      sketch.gridShapes = () => {
        for (let indexX = padding; indexX < tiles - padding; indexX++) {
          for (let indexY = padding; indexY < tiles - padding; indexY++) {
            if (
              (indexX != initials[0].x || indexY != initials[0].y) &&
              (indexX != initials[1].x || indexY != initials[1].y)
            ) {
              const posX = (sketch.width / tiles) * indexX;
              const posY = (sketch.height / tiles) * indexY;
              const randomShape = Math.floor(sketch.random(188));
              sketch.noFill();
              sketch.noStroke();
              sketch.translate(posX, posY);

              sketch.push();
              // add random color
              const randomShapeSize = sketch.random(0.9, 1);
              sketch.scale(randomShapeSize);
              // random color
              const randomShapeColor = Math.floor(sketch.random(3));
              switch (randomShapeColor) {
                case 0:
                  shapeColor = this.data.DarkVibrant;
                  break;
                case 1:
                  shapeColor = this.data.Muted;
                  break;
                case 2:
                  shapeColor = this.data.LightMuted;
                  break;
                default:
                  break;
              }
              sketch.strokeWeight(4.5);
              // center
              sketch.translate(tiles, tiles);
              // random translate
              sketch.translate(unit * sketch.random(-0.25, 0.25), 0);
              switch (randomShape) {
                case 0:
                  sketch.gridCircle(shapeColor);
                  break;
                case 1:
                  sketch.gridEye(shapeColor);
                  break;
                case 2:
                  sketch.gridGraph(shapeColor);
                  break;
                case 3:
                  sketch.gridWave(shapeColor);
                  break;
                case 4:
                  sketch.gridStairs(shapeColor);
                  break;
                case 5:
                  sketch.gridEyeCircle(shapeColor);
                  break;
                case 6:
                  sketch.gridCircle(shapeColor);
                  break;
                case 7:
                  sketch.gridCirclePeace(shapeColor);
                  break;
                case 8:
                  sketch.gridCircleHorizontal(shapeColor);
                  break;
                case 9:
                  sketch.gridCircleVertical(shapeColor);
                  break;
                case 10:
                  sketch.gridCirclePoint(shapeColor);
                  break;
                case 11:
                  sketch.gridCircleDiagonal(shapeColor);
                  break;
                case 12:
                  sketch.gridCircleSquare(shapeColor);
                  break;
                case 13:
                  sketch.gridCircleDiamond(shapeColor);
                  break;
                case 14:
                  sketch.gridSquare(shapeColor);
                  break;
                case 15:
                  sketch.gridSquareDiamondWindow(shapeColor);
                  break;
                case 16:
                  sketch.gridSquareDiamond(shapeColor);
                  break;
                case 17:
                  sketch.gridSquareOpenAlt(shapeColor);
                  break;
                case 18:
                  sketch.gridSquareDiagonal(shapeColor);
                  break;
                case 19:
                  sketch.gridSquareWindow(shapeColor);
                  break;
                case 20:
                  sketch.gridSquareOpen(shapeColor);
                  break;
                case 21:
                  sketch.gridDiamond(shapeColor);
                  break;
                case 22:
                  sketch.gridDiamondHalfLeft(shapeColor);
                  break;
                case 23:
                  sketch.gridDiamondHalfRight(shapeColor);
                  break;
                case 24:
                  sketch.gridDiamondVertical(shapeColor);
                  break;
                case 25:
                  sketch.gridDiamondHorizontal(shapeColor);
                  break;
                case 26:
                  sketch.gridDiamondDiagonal(shapeColor);
                  break;
                case 27:
                  sketch.gridTriangle(shapeColor);
                  break;
                case 28:
                  sketch.gridTriangleOpen(shapeColor);
                  break;
                case 29:
                  sketch.gridTriangleArrow(shapeColor);
                  break;
                case 30:
                  sketch.gridTriangleDiagonal(shapeColor);
                  break;
                case 31:
                  sketch.gridTriangleNuclear(shapeColor);
                  break;
                case 32:
                  sketch.gridArcDown(shapeColor);
                  break;
                case 33:
                  sketch.gridArcUp(shapeColor);
                  break;
                case 34:
                  sketch.gridArcUpRight(shapeColor);
                  break;
                case 35:
                  sketch.gridArcUpLeft(shapeColor);
                  break;
                case 36:
                  sketch.gridArcDownLeft(shapeColor);
                  break;
                case 37:
                  sketch.gridArcDownRight(shapeColor);
                  break;
                case 38:
                  sketch.gridRect(shapeColor);
                  break;
                case 39:
                  sketch.gridRectVertical(shapeColor);
                  break;
                case 40:
                  sketch.gridRectDiagonalRight(shapeColor);
                  break;
                case 41:
                  sketch.gridRectDiagonalLeft(shapeColor);
                  break;
                case 42:
                  sketch.gridCross(shapeColor);
                  break;
                case 43:
                  sketch.gridLRDline(shapeColor);
                  break;
                case 44:
                  sketch.gridRLDline(shapeColor);
                  break;
                case 45:
                  sketch.gridVerticalLine(shapeColor);
                  break;
                case 46:
                  sketch.gridHorizontalLine(shapeColor);
                  break;
                case 47:
                  sketch.gridHorizontal3Lines(shapeColor);
                  break;
                case 48:
                  sketch.gridCrossDashed(shapeColor);
                  break;
                case 49:
                  sketch.gridDiagonal3Lines(shapeColor);
                  break;
                case 50:
                  sketch.gridMorpion(shapeColor);
                  break;
                case 51:
                  sketch.gridHexagon(shapeColor);
                  break;
                case 52:
                  sketch.gridHexagonDashed(shapeColor);
                  break;
                case 53:
                  sketch.gridHexagonLine(shapeColor);
                  break;
                case 54:
                  sketch.gridPentagon(shapeColor);
                  break;
                case 55:
                  sketch.gridPentagonCross(shapeColor);
                  break;
                case 56:
                  sketch.gridStar(shapeColor);
                  break;
                case 57:
                  sketch.gridStarRotated(shapeColor);
                  break;
                case 58:
                  sketch.gridStarRotatedLine(shapeColor);
                  break;
                case 59:
                  sketch.gridStarRound(shapeColor);
                  break;
                case 60:
                  sketch.gridTear(shapeColor);
                  break;
                case 61:
                  sketch.gridTearHalf(shapeColor);
                  break;
                case 62:
                  sketch.gridTearDiagonal(shapeColor);
                  break;
                case 63:
                  sketch.gridMoon(shapeColor);
                  break;
                case 64:
                  sketch.gridMoonHorizontal(shapeColor);
                  break;
                case 65:
                  sketch.gridMoonDiagonal(shapeColor);
                  break;
                case 66:
                  sketch.gridMoonDown(shapeColor);
                  break;
                default:
                  break;
              }
              sketch.pop();

              sketch.translate(-1 * posX, -1 * posY);
            }
          }
        }
      };

      /**
       *
       * - DRAWINGS FUNCS - BACKGROUND SHAPES
       */
      sketch.bgCircle = () => {
        sketch.ellipse(unit * center, unit * center, unit * 3, unit * 3);
      };

      sketch.bgSquare = () => {
        sketch.rect(unit * center, unit * center, unit * 3, unit * 3);
      };

      sketch.bgDiamond = () => {
        sketch.beginShape();
        sketch.vertex(unit * center, unit * 1.125);
        sketch.vertex(unit * 4.875, unit * center);
        sketch.vertex(unit * center, unit * 4.875);
        sketch.vertex(unit * 1.125, unit * center);
        sketch.endShape();
      };

      sketch.bgTriangle = () => {
        sketch.triangle(
          unit * 1.125,
          unit * 1.875,
          unit * 4.875,
          unit * 1.875,
          unit * center,
          unit * 4.875
        );
      };

      sketch.bgArc = () => {
        sketch.arc(
          unit * center,
          unit * 2.625,
          unit * 4.125,
          unit * 4.125,
          unit * 0,
          sketch.PI
        );
      };

      sketch.bgRect = () => {
        sketch.rect(unit * center, unit * center, unit * 4.125, unit * 1.5);
      };

      sketch.bgEye = () => {
        sketch.beginShape();
        sketch.vertex(unit * 1.125, unit * center);
        sketch.bezierVertex(
          unit * 1.875,
          unit * 1.875,
          unit * 4.125,
          unit * 1.875,
          unit * 4.875,
          unit * center
        );
        sketch.bezierVertex(
          unit * 4.125,
          unit * 4.125,
          unit * 1.875,
          unit * 4.125,
          unit * 1.125,
          unit * center
        );
        sketch.endShape();
      };

      sketch.bgCross = () => {
        sketch.beginShape();
        sketch.vertex(unit * 1.875, unit * 1.125);
        sketch.vertex(unit * center, unit * 2.25);
        sketch.vertex(unit * 4.125, unit * 1.125);
        sketch.vertex(unit * 4.875, unit * 1.875);
        sketch.vertex(unit * 3.75, unit * 3);
        sketch.vertex(unit * 4.875, unit * 4.125);
        sketch.vertex(unit * 4.125, unit * 4.875);
        sketch.vertex(unit * center, unit * 3.75);
        sketch.vertex(unit * 1.875, unit * 4.875);
        sketch.vertex(unit * 1.125, unit * 4.125);
        sketch.vertex(unit * 2.25, unit * 3);
        sketch.vertex(unit * 1.125, unit * 1.875);
        sketch.endShape();
      };

      sketch.bgPolygon = () => {
        sketch.beginShape();
        sketch.vertex(unit * 1.875, unit * 1.5);
        sketch.vertex(unit * 4.125, unit * 1.5);
        sketch.vertex(unit * 4.875, unit * center);
        sketch.vertex(unit * 4.125, unit * 4.5);
        sketch.vertex(unit * 1.875, unit * 4.5);
        sketch.vertex(unit * 1.125, unit * center);
        sketch.endShape();
      };

      sketch.bgStar = () => {
        sketch.beginShape();
        sketch.vertex(unit * center, unit * 1.125);
        sketch.vertex(unit * 3.75, unit * 2.25);
        sketch.vertex(unit * 4.875, unit * center);
        sketch.vertex(unit * 3.75, unit * 3.75);
        sketch.vertex(unit * center, unit * 4.875);
        sketch.vertex(unit * 2.25, unit * 3.75);
        sketch.vertex(unit * 1.125, unit * center);
        sketch.vertex(unit * 2.25, unit * 2.25);
        sketch.endShape();
      };

      sketch.bgTear = () => {
        sketch.beginShape();
        sketch.vertex(unit * center, unit * 1.125);
        sketch.bezierVertex(
          unit * 4.875,
          unit * 4.125,
          unit * 4.125,
          unit * 4.5,
          unit * center,
          unit * 4.5
        );
        sketch.bezierVertex(
          unit * 1.875,
          unit * 4.5,
          unit * 1.125,
          unit * 4.125,
          unit * center,
          unit * 1.125
        );
        sketch.endShape();
      };

      sketch.bgMoon = () => {
        sketch.beginShape();
        sketch.vertex(unit * 4.125, unit * 1.125);
        sketch.bezierVertex(
          unit * 0.375,
          unit * 0,
          unit * 0.375,
          unit * 6,
          unit * 4.125,
          unit * 4.875
        );

        sketch.bezierVertex(
          unit * 1.875,
          unit * 4.125,
          unit * 1.875,
          unit * 1.875,
          unit * 4.125,
          unit * 1.125
        );
        sketch.endShape();
      };

      /**
       *
       * - DRAWINGS FUNCS - GRID SHAPES
       */

      sketch.gridCircle = fillColor => {
        sketch.stroke(fillColor);
        sketch.ellipse(
          sketch.width / tiles / 2,
          sketch.height / tiles / 2,
          (sketch.width / tiles) * 0.9,
          (sketch.height / tiles) * 0.9
        );
      };

      sketch.gridCirclePeace = fillColor => {
        sketch.noFill();
        sketch.stroke(fillColor);
        sketch.ellipse(unit * 0.5, unit * 0.5, unit * 0.9, unit * 0.9);

        sketch.beginShape(sketch.LINES);
        sketch.vertex(unit * 0.5, unit * 0.05);
        sketch.vertex(unit * 0.5, unit * 0.5);
        sketch.endShape();

        sketch.beginShape(sketch.LINES);
        sketch.vertex(unit * 0.05, unit * 0.5);
        sketch.vertex(unit * 0.95, unit * 0.5);
        sketch.endShape();
      };

      sketch.gridCircleHorizontal = fillColor => {
        sketch.noFill();
        sketch.stroke(fillColor);
        sketch.ellipse(unit * 0.5, unit * 0.5, unit * 0.9, unit * 0.9);

        sketch.beginShape(sketch.LINES);
        sketch.vertex(unit * 0.05, unit * 0.5);
        sketch.vertex(unit * 0.95, unit * 0.5);
        sketch.endShape();
      };

      sketch.gridCircleVertical = fillColor => {
        sketch.noFill();
        sketch.stroke(fillColor);
        sketch.ellipse(unit * 0.5, unit * 0.5, unit * 0.9, unit * 0.9);

        sketch.beginShape(sketch.LINES);
        sketch.vertex(unit * 0.5, unit * 0.05);
        sketch.vertex(unit * 0.5, unit * 0.95);
        sketch.endShape();
      };

      sketch.gridCirclePoint = fillColor => {
        sketch.noFill();
        sketch.stroke(fillColor);
        sketch.ellipse(unit * 0.5, unit * 0.5, unit * 0.9, unit * 0.9);

        sketch.fill(fillColor);
        sketch.noStroke();
        sketch.ellipse(unit * 0.5, unit * 0.5, unit * 0.25, unit * 0.25);
      };

      sketch.gridCircleDiagonal = fillColor => {
        const localUnit = unit / 8;
        sketch.noFill();
        sketch.stroke(fillColor);
        sketch.ellipse(unit * 0.5, unit * 0.5, unit * 0.9, unit * 0.9);

        sketch.beginShape(sketch.LINES);
        sketch.vertex(localUnit * 0.75, localUnit * 4);
        sketch.vertex(localUnit * 5.5, localUnit * 1);
        sketch.endShape();

        sketch.beginShape(sketch.LINES);
        sketch.vertex(localUnit * 1.25, localUnit * 5.5);
        sketch.vertex(localUnit * 7, localUnit * 2);
        sketch.endShape();

        sketch.beginShape(sketch.LINES);
        sketch.vertex(localUnit * 2.5, localUnit * 7);
        sketch.vertex(localUnit * 7.5, localUnit * 3.5);
        sketch.endShape();
      };

      sketch.gridCircleSquare = fillColor => {
        sketch.noFill();
        sketch.stroke(fillColor);
        sketch.ellipse(unit * 0.5, unit * 0.5, unit * 0.9, unit * 0.9);

        sketch.rect(unit * 0.5, unit * 0.5, unit * 0.55, unit * 0.55);
      };

      sketch.gridCircleDiamond = fillColor => {
        sketch.noFill();
        sketch.stroke(fillColor);
        sketch.ellipse(unit * 0.5, unit * 0.5, unit * 0.9, unit * 0.9);

        sketch.beginShape();
        sketch.vertex(unit * 0.5, unit * 0.2);
        sketch.vertex(unit * 0.8, unit * 0.5);
        sketch.vertex(unit * 0.5, unit * 0.8);
        sketch.vertex(unit * 0.2, unit * 0.5);
        sketch.endShape(sketch.CLOSE);
      };

      sketch.gridSquare = fillColor => {
        sketch.noFill();
        sketch.stroke(fillColor);
        sketch.rect(unit * 0.5, unit * 0.5, unit * 0.8, unit * 0.8);
      };

      sketch.gridSquareOpen = fillColor => {
        sketch.noFill();
        sketch.stroke(fillColor);

        sketch.beginShape();
        sketch.vertex(unit * 0.25, unit * 0.75);
        sketch.vertex(unit * 0.25, unit * 0.25);
        sketch.vertex(unit * 0.75, unit * 0.25);
        sketch.vertex(unit * 0.75, unit * 0.75);
        sketch.endShape();
      };

      sketch.gridSquareWindow = fillColor => {
        sketch.noFill();
        sketch.stroke(fillColor);
        sketch.rect(unit * 0.5, unit * 0.5, unit * 0.8, unit * 0.8);

        sketch.beginShape();
        sketch.vertex(unit * 0.5, unit * 0.1);
        sketch.vertex(unit * 0.5, unit * 0.9);
        sketch.endShape();

        sketch.beginShape();
        sketch.vertex(unit * 0.1, unit * 0.5);
        sketch.vertex(unit * 0.9, unit * 0.5);
        sketch.endShape();
      };

      sketch.gridSquareDiagonal = fillColor => {
        const localUnit = unit / 8;
        sketch.noFill();
        sketch.stroke(fillColor);
        sketch.rect(unit * 0.5, unit * 0.5, unit * 0.8, unit * 0.8);

        sketch.beginShape();
        sketch.vertex(localUnit * 1, localUnit * 3);
        sketch.vertex(localUnit * 3, localUnit * 1);
        sketch.endShape();

        sketch.beginShape();
        sketch.vertex(localUnit * 1, localUnit * 5);
        sketch.vertex(localUnit * 5, localUnit * 1);
        sketch.endShape();

        sketch.beginShape();
        sketch.vertex(localUnit * 7, localUnit * 1);
        sketch.vertex(localUnit * 1, localUnit * 7);
        sketch.endShape();

        sketch.beginShape();
        sketch.vertex(localUnit * 3, localUnit * 7);
        sketch.vertex(localUnit * 7, localUnit * 3);
        sketch.endShape();

        sketch.beginShape();
        sketch.vertex(localUnit * 5, localUnit * 7);
        sketch.vertex(localUnit * 7, localUnit * 5);
        sketch.endShape();
      };

      sketch.gridSquareOpenAlt = fillColor => {
        sketch.noFill();
        sketch.stroke(fillColor);

        sketch.beginShape();
        sketch.vertex(unit * 0.25, unit * 0.75);
        sketch.vertex(unit * 0.25, unit * 0.25);
        sketch.vertex(unit * 0.75, unit * 0.25);
        sketch.vertex(unit * 0.75, unit * 0.75);
        sketch.endShape();

        sketch.beginShape();
        sketch.vertex(unit * 0.25, unit * 0.75);
        sketch.vertex(unit * 0.75, unit * 0.25);
        sketch.endShape();

        sketch.beginShape();
        sketch.vertex(unit * 0.25, unit * 0.25);
        sketch.vertex(unit * 0.75, unit * 0.75);
        sketch.endShape();
      };

      sketch.gridSquareDiamond = fillColor => {
        sketch.noFill();
        sketch.stroke(fillColor);
        sketch.beginShape();
        sketch.vertex(unit * 0.5, unit * 0.1);
        sketch.vertex(unit * 0.9, unit * 0.5);
        sketch.vertex(unit * 0.5, unit * 0.9);
        sketch.vertex(unit * 0.1, unit * 0.5);
        sketch.vertex(unit * 0.5, unit * 0.1);
        sketch.endShape();
      };

      sketch.gridSquareDiamondWindow = fillColor => {
        sketch.noFill();
        sketch.stroke(fillColor);
        sketch.beginShape();
        sketch.vertex(unit * 0.5, unit * 0.1);
        sketch.vertex(unit * 0.9, unit * 0.5);
        sketch.vertex(unit * 0.5, unit * 0.9);
        sketch.vertex(unit * 0.1, unit * 0.5);
        sketch.vertex(unit * 0.5, unit * 0.1);
        sketch.endShape();

        sketch.beginShape();
        sketch.vertex(unit * 0.3, unit * 0.3);
        sketch.vertex(unit * 0.7, unit * 0.7);
        sketch.endShape();

        sketch.beginShape();
        sketch.vertex(unit * 0.7, unit * 0.3);
        sketch.vertex(unit * 0.3, unit * 0.7);
        sketch.endShape();
      };

      sketch.gridDiamond = fillColor => {
        sketch.noFill();
        sketch.stroke(fillColor);
        sketch.beginShape();
        sketch.vertex(unit * 0.5, unit * 0.05);
        sketch.vertex(unit * 0.75, unit * 0.5);
        sketch.vertex(unit * 0.5, unit * 0.95);
        sketch.vertex(unit * 0.25, unit * 0.5);
        sketch.vertex(unit * 0.5, unit * 0.05);
        sketch.endShape();
      };

      sketch.gridDiamondHalfLeft = fillColor => {
        sketch.noFill();
        sketch.stroke(fillColor);
        sketch.beginShape();
        sketch.vertex(unit * 0.5, unit * 0.05);
        sketch.vertex(unit * 0.25, unit * 0.5);
        sketch.vertex(unit * 0.5, unit * 0.95);
        sketch.endShape();
      };

      sketch.gridDiamondHalfRight = fillColor => {
        sketch.noFill();
        sketch.stroke(fillColor);
        sketch.beginShape();
        sketch.vertex(unit * 0.5, unit * 0.05);
        sketch.vertex(unit * 0.75, unit * 0.5);
        sketch.vertex(unit * 0.5, unit * 0.95);
        sketch.endShape();
      };

      sketch.gridDiamondVertical = fillColor => {
        sketch.noFill();
        sketch.stroke(fillColor);
        sketch.beginShape();
        sketch.vertex(unit * 0.5, unit * 0.05);
        sketch.vertex(unit * 0.75, unit * 0.5);
        sketch.vertex(unit * 0.5, unit * 0.95);
        sketch.vertex(unit * 0.25, unit * 0.5);
        sketch.vertex(unit * 0.5, unit * 0.05);
        sketch.endShape();

        sketch.beginShape();
        sketch.vertex(unit * 0.5, unit * 0.05);
        sketch.vertex(unit * 0.5, unit * 0.95);
        sketch.endShape();
      };

      sketch.gridDiamondHorizontal = fillColor => {
        sketch.noFill();
        sketch.stroke(fillColor);
        sketch.beginShape();
        sketch.vertex(unit * 0.5, unit * 0.05);
        sketch.vertex(unit * 0.75, unit * 0.5);
        sketch.vertex(unit * 0.5, unit * 0.95);
        sketch.vertex(unit * 0.25, unit * 0.5);
        sketch.vertex(unit * 0.5, unit * 0.05);
        sketch.endShape();

        sketch.beginShape();
        sketch.vertex(unit * 0.25, unit * 0.5);
        sketch.vertex(unit * 0.75, unit * 0.5);
        sketch.endShape();
      };

      sketch.gridDiamondDiagonal = fillColor => {
        const localUnit = unit / 8;
        sketch.noFill();
        sketch.stroke(fillColor);
        sketch.beginShape();
        sketch.vertex(unit * 0.5, unit * 0.05);
        sketch.vertex(unit * 0.75, unit * 0.5);
        sketch.vertex(unit * 0.5, unit * 0.95);
        sketch.vertex(unit * 0.25, unit * 0.5);
        sketch.vertex(unit * 0.5, unit * 0.05);
        sketch.endShape();

        sketch.beginShape();
        sketch.vertex(localUnit * 2.5, localUnit * 5);
        sketch.vertex(localUnit * 4.5, localUnit * 1.5);
        sketch.endShape();

        sketch.beginShape();
        sketch.vertex(localUnit * 3, localUnit * 6);
        sketch.vertex(localUnit * 5, localUnit * 2.5);
        sketch.endShape();

        sketch.beginShape();
        sketch.vertex(localUnit * 3.55, localUnit * 7);
        sketch.vertex(localUnit * 5.5, localUnit * 3.5);
        sketch.endShape();
      };

      sketch.gridTriangle = fillColor => {
        sketch.noFill();
        sketch.stroke(fillColor);
        sketch.triangle(
          unit * 0.5,
          unit * 0.1,
          unit * 0.9,
          unit * 0.9,
          unit * 0.1,
          unit * 0.9
        );
      };

      sketch.gridTriangleOpen = fillColor => {
        sketch.noFill();
        sketch.stroke(fillColor);
        sketch.beginShape();
        sketch.vertex(unit * 0.1, unit * 0.9);
        sketch.vertex(unit * 0.5, unit * 0.1);
        sketch.vertex(unit * 0.9, unit * 0.9);
        sketch.endShape();
      };

      sketch.gridTriangleArrow = fillColor => {
        sketch.noFill();
        sketch.stroke(fillColor);

        sketch.triangle(
          unit * 0.5,
          unit * 0.1,
          unit * 0.5,
          unit * 0.9,
          unit * 0.1,
          unit * 0.5
        );

        sketch.beginShape();
        sketch.vertex(unit * 0.1, unit * 0.5);
        sketch.vertex(unit * 0.9, unit * 0.5);
        sketch.endShape();
      };

      sketch.gridTriangleDiagonal = fillColor => {
        sketch.noFill();
        sketch.stroke(fillColor);
        sketch.triangle(
          unit * 0.5,
          unit * 0.1,
          unit * 0.1,
          unit * 0.9,
          unit * 0.9,
          unit * 0.9
        );

        sketch.beginShape();
        sketch.vertex(unit * 0.25, unit * 0.9);
        sketch.vertex(unit * 0.58, unit * 0.25);
        sketch.endShape();

        sketch.beginShape();
        sketch.vertex(unit * 0.4, unit * 0.9);
        sketch.vertex(unit * 0.65, unit * 0.4);
        sketch.endShape();

        sketch.beginShape();
        sketch.vertex(unit * 0.55, unit * 0.9);
        sketch.vertex(unit * 0.72, unit * 0.6);
        sketch.endShape();
      };

      sketch.gridTriangleNuclear = fillColor => {
        sketch.noFill();
        sketch.stroke(fillColor);
        sketch.triangle(
          unit * 0.5,
          unit * 0.1,
          unit * 0.9,
          unit * 0.9,
          unit * 0.1,
          unit * 0.9
        );

        sketch.beginShape();
        sketch.vertex(unit * 0.5, unit * 0.1);
        sketch.vertex(unit * 0.5, unit * 0.5);
        sketch.endShape();

        sketch.beginShape();
        sketch.vertex(unit * 0.1, unit * 0.9);
        sketch.vertex(unit * 0.5, unit * 0.5);
        sketch.endShape();

        sketch.beginShape();
        sketch.vertex(unit * 0.9, unit * 0.9);
        sketch.vertex(unit * 0.5, unit * 0.5);
        sketch.endShape();
      };

      sketch.gridArcDown = fillColor => {
        sketch.noFill();
        sketch.stroke(fillColor);

        sketch.beginShape();
        sketch.vertex(unit * 0.1, unit * 0.1);
        sketch.bezierVertex(
          unit * 0.1,
          unit * 0.75,
          unit * 0.9,
          unit * 0.75,
          unit * 0.9,
          unit * 0.1
        );
        sketch.endShape();
      };

      sketch.gridArcUp = fillColor => {
        sketch.noFill();
        sketch.stroke(fillColor);

        sketch.beginShape();
        sketch.vertex(unit * 0.1, unit * 0.9);
        sketch.bezierVertex(
          unit * 0.1,
          unit * 0.25,
          unit * 0.9,
          unit * 0.25,
          unit * 0.9,
          unit * 0.9
        );
        sketch.endShape();
      };

      sketch.gridArcUpRight = fillColor => {
        sketch.noFill();
        sketch.stroke(fillColor);

        sketch.beginShape();
        sketch.vertex(unit * 0.1, unit * 0.1);
        sketch.bezierVertex(
          unit * 0.75,
          unit * 0.1,
          unit * 0.9,
          unit * 0.75,
          unit * 0.9,
          unit * 0.9
        );
        sketch.endShape();
      };

      sketch.gridArcDownLeft = fillColor => {
        sketch.noFill();
        sketch.stroke(fillColor);

        sketch.beginShape();
        sketch.vertex(unit * 0.1, unit * 0.1);
        sketch.bezierVertex(
          unit * 0.1,
          unit * 0.75,
          unit * 0.25,
          unit * 0.9,
          unit * 0.9,
          unit * 0.9
        );
        sketch.endShape();
      };

      sketch.gridArcDownRight = fillColor => {
        sketch.noFill();
        sketch.stroke(fillColor);

        sketch.beginShape();
        sketch.vertex(unit * 0.9, unit * 0.1);
        sketch.bezierVertex(
          unit * 0.9,
          unit * 0.75,
          unit * 0.75,
          unit * 0.9,
          unit * 0.1,
          unit * 0.9
        );
        sketch.endShape();
      };

      sketch.gridArcUpLeft = fillColor => {
        sketch.noFill();
        sketch.stroke(fillColor);

        sketch.beginShape();
        sketch.vertex(unit * 0.9, unit * 0.1);
        sketch.bezierVertex(
          unit * 0.25,
          unit * 0.1,
          unit * 0.1,
          unit * 0.25,
          unit * 0.1,
          unit * 0.9
        );
        sketch.endShape();
      };

      sketch.gridRect = fillColor => {
        sketch.noFill();
        sketch.stroke(fillColor);
        sketch.rect(unit * 0.5, unit * 0.5, unit * 0.9, unit * 0.4);
      };

      sketch.gridRectVertical = fillColor => {
        sketch.noFill();
        sketch.stroke(fillColor);
        sketch.rect(unit * 0.5, unit * 0.5, unit * 0.9, unit * 0.4);

        sketch.beginShape();
        sketch.vertex(unit * 0.275, unit * 0.3);
        sketch.vertex(unit * 0.275, unit * 0.7);
        sketch.endShape();

        sketch.beginShape();
        sketch.vertex(unit * 0.5, unit * 0.3);
        sketch.vertex(unit * 0.5, unit * 0.7);
        sketch.endShape();

        sketch.beginShape();
        sketch.vertex(unit * 0.725, unit * 0.3);
        sketch.vertex(unit * 0.725, unit * 0.7);
        sketch.endShape();
      };

      sketch.gridRectDiagonalRight = fillColor => {
        sketch.noFill();
        sketch.stroke(fillColor);
        sketch.rect(unit * 0.5, unit * 0.5, unit * 0.9, unit * 0.4);

        sketch.beginShape();
        sketch.vertex(unit * 0.05, unit * 0.7);
        sketch.vertex(unit * 0.275, unit * 0.3);
        sketch.endShape();

        sketch.beginShape();
        sketch.vertex(unit * 0.275, unit * 0.7);
        sketch.vertex(unit * 0.5, unit * 0.3);
        sketch.endShape();

        sketch.beginShape();
        sketch.vertex(unit * 0.5, unit * 0.7);
        sketch.vertex(unit * 0.725, unit * 0.3);
        sketch.endShape();

        sketch.beginShape();
        sketch.vertex(unit * 0.725, unit * 0.7);
        sketch.vertex(unit * 0.95, unit * 0.3);
        sketch.endShape();
      };

      sketch.gridRectDiagonalLeft = fillColor => {
        sketch.noFill();
        sketch.stroke(fillColor);
        sketch.rect(unit * 0.5, unit * 0.5, unit * 0.9, unit * 0.4);

        sketch.beginShape();
        sketch.vertex(unit * 0.05, unit * 0.3);
        sketch.vertex(unit * 0.275, unit * 0.7);
        sketch.endShape();

        sketch.beginShape();
        sketch.vertex(unit * 0.275, unit * 0.3);
        sketch.vertex(unit * 0.5, unit * 0.7);
        sketch.endShape();

        sketch.beginShape();
        sketch.vertex(unit * 0.5, unit * 0.3);
        sketch.vertex(unit * 0.725, unit * 0.7);
        sketch.endShape();

        sketch.beginShape();
        sketch.vertex(unit * 0.725, unit * 0.3);
        sketch.vertex(unit * 0.95, unit * 0.7);
        sketch.endShape();
      };

      sketch.gridEye = fillColor => {
        sketch.stroke(fillColor);
        sketch.beginShape();
        sketch.vertex(unit * 0.1, unit * 0.5);
        sketch.bezierVertex(
          unit * 0.5,
          unit * 0.25,
          unit * 0.5,
          unit * 0.25,
          unit * 0.9,
          unit * 0.5
        );
        sketch.bezierVertex(
          unit * 0.5,
          unit * 0.75,
          unit * 0.5,
          unit * 0.75,
          unit * 0.1,
          unit * 0.5
        );
        sketch.endShape();
      };

      sketch.gridEyeCircle = color => {
        sketch.stroke(color);
        sketch.beginShape();
        sketch.vertex(unit * 0.1, unit * 0.5);
        sketch.bezierVertex(
          unit * 0.5,
          unit * 0.25,
          unit * 0.5,
          unit * 0.25,
          unit * 0.9,
          unit * 0.5
        );
        sketch.bezierVertex(
          unit * 0.5,
          unit * 0.75,
          unit * 0.5,
          unit * 0.75,
          unit * 0.1,
          unit * 0.5
        );
        sketch.endShape();
        sketch.noStroke();
        sketch.fill(color);
        sketch.ellipse(unit / 2, unit / 2, 10, 10);
      };

      sketch.gridGraph = fillColor => {
        sketch.stroke(fillColor);
        sketch.beginShape();
        sketch.vertex(0.5 * (unit / 6), unit * 0.66);
        sketch.vertex(1.5 * (unit / 6), unit * 0.33);
        sketch.vertex(2.5 * (unit / 6), unit * 0.66);
        sketch.vertex(3.5 * (unit / 6), unit * 0.33);
        sketch.vertex(4.5 * (unit / 6), unit * 0.66);
        sketch.vertex(5.5 * (unit / 6), unit * 0.33);
        sketch.endShape();
      };

      sketch.gridWave = fillColor => {
        sketch.stroke(fillColor);
        sketch.beginShape();
        sketch.vertex(0, unit / 2);
        sketch.bezierVertex(
          2 * (unit / 3 / 10),
          11 * (unit / 3 / 10),
          unit / 3 - 2 * (unit / 3 / 10),
          11 * (unit / 3 / 10),
          unit / 3,
          unit / 2
        );
        sketch.endShape();

        sketch.translate(unit / 3, 0);
        sketch.beginShape();
        sketch.vertex(0, unit / 2);
        sketch.bezierVertex(
          2 * (unit / 3 / 10),
          18 * (unit / 3 / 10),
          unit / 3 - 2 * (unit / 3 / 10),
          18 * (unit / 3 / 10),
          unit / 3,
          unit / 2
        );
        sketch.endShape();
        sketch.translate(unit / 3, 0);

        sketch.beginShape();
        sketch.vertex(0, unit / 2);
        sketch.bezierVertex(
          2 * (unit / 3 / 10),
          11 * (unit / 3 / 10),
          unit / 3 - 2 * (unit / 3 / 10),
          11 * (unit / 3 / 10),
          unit / 3,
          unit / 2
        );
        sketch.endShape();

        sketch.translate(-2 * (unit / 3), 0);
      };

      sketch.gridStairs = fillColor => {
        sketch.stroke(fillColor);
        sketch.translate(unit / 7, unit / 7);
        const localUnit = unit / 10;
        sketch.beginShape();
        sketch.vertex(localUnit * 0.5, localUnit * 2);
        sketch.vertex(localUnit * 2.5, localUnit * 2);
        sketch.vertex(localUnit * 2.5, localUnit * 3);
        sketch.vertex(localUnit * 4.5, localUnit * 3);
        sketch.vertex(localUnit * 4.5, localUnit * 4);
        sketch.vertex(localUnit * 6.5, localUnit * 4);
        sketch.vertex(localUnit * 6.5, localUnit * 5);
        sketch.endShape();
        sketch.translate(-1 * (unit / 7), -1 * (unit / 7));
      };

      sketch.gridCross = color => {
        sketch.stroke(color);
        const localUnit = unit / 8;
        sketch.translate(unit / 2, (unit / 5) * -1);
        sketch.rotate(sketch.PI / 4);
        sketch.beginShape();
        sketch.vertex(localUnit * 3, localUnit * 1);
        sketch.vertex(localUnit * 5, localUnit * 1);
        sketch.vertex(localUnit * 5, localUnit * 3);
        sketch.vertex(localUnit * 7, localUnit * 3);
        sketch.vertex(localUnit * 7, localUnit * 5);
        sketch.vertex(localUnit * 5, localUnit * 5);
        sketch.vertex(localUnit * 5, localUnit * 7);
        sketch.vertex(localUnit * 3, localUnit * 7);
        sketch.vertex(localUnit * 3, localUnit * 5);
        sketch.vertex(localUnit * 1, localUnit * 5);
        sketch.vertex(localUnit * 1, localUnit * 3);
        sketch.vertex(localUnit * 3, localUnit * 3);
        sketch.vertex(localUnit * 3, localUnit * 1);
        sketch.endShape();
        sketch.rotate((sketch.PI / 4) * -1);
        sketch.translate((unit / 2) * -1, unit / 5);
      };

      sketch.gridLRDline = color => {
        sketch.stroke(color);
        const localUnit = unit / 8;
        sketch.line(
          localUnit * 3,
          localUnit * 4.5,
          localUnit * 5,
          localUnit * 3.5
        );
      };

      sketch.gridRLDline = color => {
        sketch.stroke(color);
        const localUnit = unit / 8;
        sketch.line(
          localUnit * 5,
          localUnit * 3.5,
          localUnit * 3,
          localUnit * 4.5
        );
      };

      sketch.gridVerticalLine = color => {
        sketch.stroke(color);
        const localUnit = unit / 8;
        sketch.line(localUnit * 4, localUnit * 5, localUnit * 4, localUnit * 3);
      };

      sketch.gridHorizontalLine = color => {
        sketch.stroke(color);
        const localUnit = unit / 8;
        sketch.line(localUnit * 3, localUnit * 4, localUnit * 5, localUnit * 4);
      };

      sketch.gridHorizontal3Lines = color => {
        sketch.stroke(color);
        const localUnit = unit / 10;
        sketch.line(localUnit * 4, localUnit * 4, localUnit * 6, localUnit * 4);
        sketch.line(localUnit * 5, localUnit * 5, localUnit * 7, localUnit * 5);
        sketch.line(localUnit * 4, localUnit * 6, localUnit * 6, localUnit * 6);
      };

      sketch.gridCrossDashed = color => {
        sketch.stroke(color);
        const localUnit = unit / 8;
        sketch.translate(unit / 2, (unit / 5) * -1);
        sketch.rotate(sketch.PI / 4);
        sketch.beginShape();
        sketch.vertex(localUnit * 3, localUnit * 1);
        sketch.vertex(localUnit * 5, localUnit * 1);
        sketch.vertex(localUnit * 5, localUnit * 3);
        sketch.vertex(localUnit * 7, localUnit * 3);
        sketch.vertex(localUnit * 7, localUnit * 5);
        sketch.vertex(localUnit * 5, localUnit * 5);
        sketch.vertex(localUnit * 5, localUnit * 7);
        sketch.vertex(localUnit * 3, localUnit * 7);
        sketch.vertex(localUnit * 3, localUnit * 5);
        sketch.vertex(localUnit * 1, localUnit * 5);
        sketch.vertex(localUnit * 1, localUnit * 3);
        sketch.vertex(localUnit * 3, localUnit * 3);
        sketch.vertex(localUnit * 3, localUnit * 1);
        sketch.endShape();

        sketch.line(localUnit * 1, localUnit * 3, localUnit * 7, localUnit * 3);
        sketch.line(localUnit * 1, localUnit * 5, localUnit * 7, localUnit * 5);
        sketch.line(localUnit * 3, localUnit * 2, localUnit * 5, localUnit * 2);
        sketch.line(localUnit * 3, localUnit * 6, localUnit * 5, localUnit * 6);

        sketch.rotate((sketch.PI / 4) * -1);
        sketch.translate((unit / 2) * -1, unit / 5);
      };

      sketch.gridDiagonal3Lines = color => {
        sketch.stroke(color);
        const localUnit = unit / 10;
        sketch.line(localUnit * 3, localUnit * 5, localUnit * 5, localUnit * 3);
        sketch.line(localUnit * 5, localUnit * 5, localUnit * 7, localUnit * 3);
        sketch.line(localUnit * 5, localUnit * 7, localUnit * 7, localUnit * 5);
      };

      sketch.gridMorpion = color => {
        const localUnit = unit / 10;
        sketch.translate(unit / 24, (unit / 24) * -1);

        sketch.rotate(sketch.PI / 24);
        sketch.stroke(color);
        sketch.strokeWeight(5);
        sketch.line(localUnit * 2, localUnit * 4, localUnit * 8, localUnit * 4);
        sketch.line(localUnit * 2, localUnit * 6, localUnit * 8, localUnit * 6);
        sketch.line(localUnit * 4, localUnit * 2, localUnit * 4, localUnit * 8);
        sketch.line(localUnit * 6, localUnit * 2, localUnit * 6, localUnit * 8);
        sketch.rotate((sketch.PI / 24) * -1);
        sketch.translate((unit / 24) * -1, unit / 24);
      };

      sketch.gridHexagon = color => {
        const localUnit = unit / 12;
        sketch.stroke(color);
        sketch.beginShape();
        sketch.vertex(localUnit * 2.25, localUnit * 6);
        sketch.vertex(localUnit * 4.25, localUnit * 2.5);
        sketch.vertex(localUnit * 8.25, localUnit * 2.5);
        sketch.vertex(localUnit * 10.25, localUnit * 6);
        sketch.vertex(localUnit * 8.25, localUnit * 9.5);
        sketch.vertex(localUnit * 4.25, localUnit * 9.5);
        sketch.endShape(sketch.CLOSE);
      };

      sketch.gridHexagonLine = color => {
        const localUnit = unit / 12;
        sketch.stroke(color);
        sketch.beginShape();
        sketch.vertex(localUnit * 2.25, localUnit * 6);
        sketch.vertex(localUnit * 4.25, localUnit * 2.5);
        sketch.vertex(localUnit * 8.25, localUnit * 2.5);
        sketch.vertex(localUnit * 10.25, localUnit * 6);
        sketch.vertex(localUnit * 8.25, localUnit * 9.5);
        sketch.vertex(localUnit * 4.25, localUnit * 9.5);
        sketch.endShape(sketch.CLOSE);
        sketch.beginShape();
        sketch.vertex(localUnit * 2.25, localUnit * 6);
        sketch.vertex(localUnit * 10.25, localUnit * 6);
        sketch.endShape();
      };

      sketch.gridHexagonDashed = color => {
        const localUnit = unit / 12;
        sketch.stroke(color);
        sketch.beginShape();
        sketch.vertex(localUnit * 2.25, localUnit * 6);
        sketch.vertex(localUnit * 4.25, localUnit * 2.5);
        sketch.vertex(localUnit * 8.25, localUnit * 2.5);
        sketch.vertex(localUnit * 10.25, localUnit * 6);
        sketch.vertex(localUnit * 8.25, localUnit * 9.5);
        sketch.vertex(localUnit * 4.25, localUnit * 9.5);
        sketch.endShape(sketch.CLOSE);
        sketch.beginShape();
        sketch.vertex(localUnit * 5, localUnit * 2.5);
        sketch.vertex(localUnit * 8.5, localUnit * 8.55);
        sketch.endShape();
        sketch.beginShape();
        sketch.vertex(localUnit * 4, localUnit * 3.4);
        sketch.vertex(localUnit * 7.55, localUnit * 9.5);
        sketch.endShape();
        sketch.beginShape();
        sketch.vertex(localUnit * 3.15, localUnit * 4.7);
        sketch.vertex(localUnit * 5.9, localUnit * 9.5);
        sketch.endShape();
        sketch.beginShape();
        sketch.vertex(localUnit * 6.5, localUnit * 2.5);
        sketch.vertex(localUnit * 9.25, localUnit * 7.25);
        sketch.endShape();
      };

      sketch.gridPentagon = color => {
        const localUnit = unit / 10;
        sketch.stroke(color);
        sketch.beginShape();

        sketch.vertex(localUnit * 8, localUnit * 4);
        sketch.vertex(localUnit * 5, localUnit * 2);
        sketch.vertex(localUnit * 2, localUnit * 4);
        sketch.vertex(localUnit * 3, localUnit * 8);
        sketch.vertex(localUnit * 7, localUnit * 8);
        sketch.endShape(sketch.CLOSE);
      };

      sketch.gridPentagonCross = color => {
        const localUnit = unit / 10;
        sketch.stroke(color);
        sketch.beginShape();

        sketch.vertex(localUnit * 8, localUnit * 4);
        sketch.vertex(localUnit * 5, localUnit * 2);
        sketch.vertex(localUnit * 2, localUnit * 4);
        sketch.vertex(localUnit * 3, localUnit * 8);
        sketch.vertex(localUnit * 7, localUnit * 8);
        sketch.endShape(sketch.CLOSE);
        sketch.beginShape();
        sketch.vertex(localUnit * 2, localUnit * 4);
        sketch.vertex(localUnit * 8, localUnit * 4);
        sketch.endShape();
        sketch.beginShape();
        sketch.vertex(localUnit * 5, localUnit * 2);
        sketch.vertex(localUnit * 5, localUnit * 4);
        sketch.endShape();
      };

      sketch.gridStar = color => {
        sketch.stroke(color);
        sketch.beginShape();
        sketch.vertex(unit * 0.5, unit * 0.2);
        sketch.vertex(unit * 0.6, unit * 0.4);
        sketch.vertex(unit * 0.8, unit * 0.5);
        sketch.vertex(unit * 0.6, unit * 0.6);
        sketch.vertex(unit * 0.5, unit * 0.8);
        sketch.vertex(unit * 0.4, unit * 0.6);
        sketch.vertex(unit * 0.2, unit * 0.5);
        sketch.vertex(unit * 0.4, unit * 0.4);
        sketch.endShape(sketch.CLOSE);
      };
      sketch.gridStarRotated = color => {
        const localUnit = unit / 8;
        sketch.stroke(color);
        sketch.beginShape();

        sketch.vertex(localUnit * 2, localUnit * 2);
        sketch.vertex(localUnit * 4, localUnit * 2.5);

        sketch.vertex(localUnit * 6, localUnit * 2);
        sketch.vertex(localUnit * 5.5, localUnit * 4);

        sketch.vertex(localUnit * 6, localUnit * 6);
        sketch.vertex(localUnit * 4, localUnit * 5.5);

        sketch.vertex(localUnit * 2, localUnit * 6);
        sketch.vertex(localUnit * 2.5, localUnit * 4);

        sketch.endShape(sketch.CLOSE);
      };

      sketch.gridStarRotatedLine = color => {
        const localUnit = unit / 8;
        sketch.stroke(color);
        sketch.beginShape();

        sketch.vertex(localUnit * 2, localUnit * 2);
        sketch.vertex(localUnit * 4, localUnit * 2.5);

        sketch.vertex(localUnit * 6, localUnit * 2);
        sketch.vertex(localUnit * 5.5, localUnit * 4);

        sketch.vertex(localUnit * 6, localUnit * 6);
        sketch.vertex(localUnit * 4, localUnit * 5.5);

        sketch.vertex(localUnit * 2, localUnit * 6);
        sketch.vertex(localUnit * 2.5, localUnit * 4);

        sketch.endShape(sketch.CLOSE);
        sketch.beginShape();
        sketch.vertex(localUnit * 4, localUnit * 2.5);
        sketch.vertex(localUnit * 4, localUnit * 5.5);
        sketch.endShape();
      };

      sketch.gridStarRound = color => {
        sketch.stroke(color);

        sketch.beginShape();
        sketch.vertex(unit * 0.5, unit * 0.2);
        sketch.vertex(unit * 0.6, unit * 0.4);
        sketch.vertex(unit * 0.8, unit * 0.5);
        sketch.vertex(unit * 0.6, unit * 0.6);
        sketch.vertex(unit * 0.5, unit * 0.8);
        sketch.vertex(unit * 0.4, unit * 0.6);
        sketch.vertex(unit * 0.2, unit * 0.5);
        sketch.vertex(unit * 0.4, unit * 0.4);
        sketch.endShape(sketch.CLOSE);

        sketch.ellipse(unit * 0.5, unit * 0.5, unit * 0.1, unit * 0.1);
      };

      sketch.gridTear = color => {
        sketch.stroke(color);

        sketch.beginShape();
        sketch.vertex(unit * 0.5, unit * 0.2);
        sketch.bezierVertex(
          unit * 0.8,
          unit * 0.7,
          unit * 0.7,
          unit * 0.75,
          unit * 0.5,
          unit * 0.75
        );
        sketch.bezierVertex(
          unit * 0.3,
          unit * 0.75,
          unit * 0.2,
          unit * 0.7,
          unit * 0.5,
          unit * 0.2
        );
        sketch.endShape();
      };

      sketch.gridTearHalf = color => {
        sketch.stroke(color);

        sketch.beginShape();
        sketch.vertex(unit * 0.2, unit * 0.4);
        sketch.vertex(unit * 0.8, unit * 0.4);
        sketch.endShape();

        sketch.beginShape();
        sketch.vertex(unit * 0.8, unit * 0.4);
        sketch.bezierVertex(
          unit * 0.9,
          unit * 0.7,
          unit * 0.7,
          unit * 0.8,
          unit * 0.5,
          unit * 0.8
        );
        sketch.bezierVertex(
          unit * 0.3,
          unit * 0.8,
          unit * 0.1,
          unit * 0.7,
          unit * 0.2,
          unit * 0.4
        );
        sketch.endShape();
      };

      sketch.gridTearDiagonal = color => {
        sketch.stroke(color);

        sketch.beginShape();
        sketch.vertex(unit * 0.5, unit * 0.2);
        sketch.bezierVertex(
          unit * 0.8,
          unit * 0.7,
          unit * 0.7,
          unit * 0.75,
          unit * 0.5,
          unit * 0.75
        );
        sketch.bezierVertex(
          unit * 0.3,
          unit * 0.75,
          unit * 0.2,
          unit * 0.7,
          unit * 0.5,
          unit * 0.2
        );
        sketch.endShape();

        sketch.beginShape();
        sketch.vertex(unit * 0.45, unit * 0.3);
        sketch.vertex(unit * 0.65, unit * 0.7);
        sketch.endShape();

        sketch.beginShape();
        sketch.vertex(unit * 0.4, unit * 0.4);
        sketch.vertex(unit * 0.57, unit * 0.75);
        sketch.endShape();

        sketch.beginShape();
        sketch.vertex(unit * 0.35, unit * 0.5);
        sketch.vertex(unit * 0.45, unit * 0.75);
        sketch.endShape();
      };

      sketch.gridMoon = color => {
        sketch.stroke(color);

        sketch.beginShape();
        sketch.vertex(unit * 0.68, unit * 0.18);
        sketch.bezierVertex(
          unit * 0,
          unit * 0,
          unit * 0,
          unit * 1,
          unit * 0.68,
          unit * 0.8
        );
        sketch.bezierVertex(
          unit * 0.3,
          unit * 0.68,
          unit * 0.3,
          unit * 0.3,
          unit * 0.68,
          unit * 0.18
        );
        sketch.endShape();
      };

      sketch.gridMoonHorizontal = color => {
        sketch.stroke(color);

        sketch.beginShape();
        sketch.vertex(unit * 0.68, unit * 0.18);
        sketch.bezierVertex(
          unit * 0,
          unit * 0,
          unit * 0,
          unit * 1,
          unit * 0.68,
          unit * 0.8
        );
        sketch.bezierVertex(
          unit * 0.3,
          unit * 0.68,
          unit * 0.3,
          unit * 0.3,
          unit * 0.68,
          unit * 0.18
        );
        sketch.endShape();

        sketch.beginShape();
        sketch.vertex(unit * 0.2, unit * 0.5);
        sketch.vertex(unit * 0.4, unit * 0.5);
        sketch.endShape();
      };

      sketch.gridMoonDiagonal = color => {
        sketch.stroke(color);

        sketch.beginShape();
        sketch.vertex(unit * 0.68, unit * 0.18);
        sketch.bezierVertex(
          unit * 0,
          unit * 0,
          unit * 0,
          unit * 1,
          unit * 0.68,
          unit * 0.8
        );
        sketch.bezierVertex(
          unit * 0.3,
          unit * 0.68,
          unit * 0.3,
          unit * 0.3,
          unit * 0.68,
          unit * 0.18
        );
        sketch.endShape();

        sketch.beginShape();
        sketch.vertex(unit * 0.2, unit * 0.4);
        sketch.vertex(unit * 0.47, unit * 0.3);
        sketch.endShape();

        sketch.beginShape();
        sketch.vertex(unit * 0.17, unit * 0.55);
        sketch.vertex(unit * 0.4, unit * 0.47);
        sketch.endShape();

        sketch.beginShape();
        sketch.vertex(unit * 0.22, unit * 0.67);
        sketch.vertex(unit * 0.43, unit * 0.6);
        sketch.endShape();

        sketch.beginShape();
        sketch.vertex(unit * 0.35, unit * 0.79);
        sketch.vertex(unit * 0.55, unit * 0.73);
        sketch.endShape();
      };

      sketch.gridMoonDown = color => {
        sketch.stroke(color);

        sketch.beginShape();
        sketch.vertex(unit * 0.15, unit * 0.75);
        sketch.bezierVertex(
          unit * 0,
          unit * 0.2,
          unit * 1,
          unit * 0.2,
          unit * 0.85,
          unit * 0.75
        );
        sketch.bezierVertex(
          unit * 0.82,
          unit * 0.5,
          unit * 0.18,
          unit * 0.5,
          unit * 0.15,
          unit * 0.75
        );
        sketch.endShape();
      };
    }
  }
};
</script>

<style>
</style>
